import { Record as record, List } from 'immutable';

import { serialize, serializers } from '../helpers/SearchUrls';
import { getDefaults, getResolvers } from '../helpers/Records';
import { construct, fields, resolve, resolveAll } from '../helpers/LinkMapper';
import CustomerServiceChangeLeg from './CustomerServiceChangeLeg';
import Station from './Station';


export const fieldSchema = {
    serviceChangeAlertId: [fields.string, null],
    cocsCustomerId: [fields.string, null],
    customerName: [fields.string, null], // anon users only
    email: [fields.string, null], // anon users only
    isEmailNotification: [fields.boolean, true],
    isCloudMessageNotification: [fields.boolean, false],
    isStationNotification: [fields.boolean, false],
    origin: [fields.string, null],
    originStationDetail: [resolve.as(Station)],
    destination: [fields.string, null],
    destinationStationDetail: [resolve.as(Station)],
    departure_time: [fields.string, null],
    departure_date: [fields.string, null],
    arrival_time: [fields.string, null],
    legs: [resolveAll.as(CustomerServiceChangeLeg), new List()],
    orderId: [fields.number, null],
    ticketId: [fields.number, null],
};

class ServiceChangeAlert extends record(
    getDefaults(fieldSchema)
) {
    static fromJSON (json = {}) {
        return construct(ServiceChangeAlert, json, getResolvers(fieldSchema));
    }

    toJSON () {
        return serialize({
            serviceChangeAlertId: serializers.identity,
            cocsCustomerId: serializers.identity,
            customerName: serializers.identity, // anon users only
            email: serializers.identity, // anon users only
            isEmailNotification: serializers.identity,
            isCloudMessageNotification: serializers.identity,
            origin: serializers.identity,
            destination: serializers.identity,
            /*
                When serialising, we need to omit the originStationDetail and destinationStationDetail
                as the API does not accept these params when creating a ServiceChangeAlert
            */
            departure_time: serializers.identity,
            departure_date: serializers.identity,
            arrival_time: serializers.identity,
            legs: legs => legs ? legs.map(leg => leg.toJSON()) : [],
            orderId: serializers.identity,
            ticketId: serializers.identity,
        }, this);
    }

    getServices () {
        return this.legs
            .groupBy(leg => leg.groupId)
            .map(service => service.sortBy(leg => leg.legOrder));
    }

    // legs holds the real per-train breakdown for this ticket leg (service_change_leg);
    // fall back to the single top-level departure time for older/legless alerts.
    getTrainDepartures () {
        if (!this.legs.size) {
            return new List([{ trainUid: null, time: this.departure_time }]);
        }

        return this.legs
            .sortBy(leg => leg.legOrder)
            .map(leg => ({ trainUid: leg.trainUid, time: leg.departureTime?.format('HH:mm') || null }));
    }
}

export default ServiceChangeAlert;
